// extracted by mini-css-extract-plugin
module.exports = {"intro":"account-type-vip-view_intro__2GjGC","title":"account-type-vip-view_title__3R6Kj","primaryEditButton":"account-type-vip-view_primaryEditButton__2nqLK"};